/** Default categories when a table has no IMPACT_CATEGORIES (company / carbon-only). */
export const CARBON_COMPARISON_CATEGORIES = [
  { name: "Tonnes CO₂e", unit: "tCO₂e", key: "carbon" },
  { name: "Tonnes CO₂e (scope 3)", unit: "tCO₂e", key: "carbon_scope_3" },
  { name: "Avoided emissions", unit: "tCO₂e", key: "avoided_emission" },
];

/** Pick a readable label from common LCA / company row fields. */
export function defaultComparisonItemLabel(item) {
  if (!item) return "";
  const pick = (value) => {
    if (value == null || value === "") return null;
    if (typeof value === "object") {
      return value.name || value.value || value.label || null;
    }
    return value;
  };

  return (
    pick(item.component) ||
    pick(item.description) ||
    pick(item.material) ||
    pick(item.nickname) ||
    pick(item.vehicle_registration) ||
    pick(item.product_name) ||
    pick(item.process) ||
    pick(item.process_name) ||
    pick(item.surplus_resource) ||
    pick(item.water_type) ||
    pick(item.machine_equipment) ||
    pick(item.production_vehicle) ||
    pick(item.transport_means) ||
    pick(item.means_of_transportation) ||
    pick(item.means_transportation) ||
    pick(item.fuel_type) ||
    pick(item.type) ||
    pick(item.type_drinking) ||
    pick(item.gas_type) ||
    pick(item.employee_name) ||
    pick(item.employee) ||
    pick(item.supplier) ||
    pick(item.client) ||
    pick(item.visiting_country) ||
    pick(item.name_of_journey) ||
    pick(item.name_maintenance_process) ||
    pick(item.name_repair_process) ||
    pick(item.name_replacement_process) ||
    pick(item.name_refurbishment_process) ||
    pick(item.name_deconstruction_sorting_processes) ||
    pick(item.name_part_in_fu) ||
    pick(item.sold_intermediate_product) ||
    pick(item.own_name) ||
    pick(item.name) ||
    `Row ${item.id ?? ""}`
  );
}

/**
 * Prefer configured categories; otherwise carbon fields that exist on any row.
 */
export function resolveComparisonCategories(categories, items = []) {
  if (Array.isArray(categories) && categories.length > 0) return categories;

  const present = CARBON_COMPARISON_CATEGORIES.filter((cat) =>
    items.some((item) => {
      const raw = item?.[cat.key];
      return raw != null && raw !== "" && !Number.isNaN(Number(raw));
    })
  );

  return present.length > 0
    ? present
    : [CARBON_COMPARISON_CATEGORIES[0]];
}
